// ============ GOOGLE OAUTH CONFIG ============
export const LOGIN_GOOGLE_OAUTH_SCOPES: string[] = [
  "openid",
  "profile",
  "email",
];

export const GMAIL_SEND_SCOPE = "https://www.googleapis.com/auth/gmail.send";
export const GMAIL_READ_SCOPE =
  "https://www.googleapis.com/auth/gmail.readonly";

// REMOVED: GCONTACTS_SCOPE - not used anywhere in codebase
// REMOVED: GOOGLE_DRIVE_FILE_SCOPES - not used (using Firebase for file uploads)
// REMOVED: GOOGLE_SPREADSHEETS_SCOPES - only used in deprecated /enrich and /qualify pages

// If you need to re-enable these scopes in the future:
// export const GCONTACTS_SCOPE = "https://www.googleapis.com/auth/contacts.readonly";
// export const GOOGLE_DRIVE_FILE_SCOPES: readonly string[] = [
//   "https://www.googleapis.com/auth/drive.file",
//   "https://www.googleapis.com/auth/drive",
//   "https://www.googleapis.com/auth/drive.readonly",
// ];
// export const GOOGLE_SPREADSHEETS_SCOPES: readonly string[] = [
//   "https://www.googleapis.com/auth/spreadsheets",
//   "https://www.googleapis.com/auth/spreadsheets.readonly",
// ];

export const GMAIL_SCOPES: string[] = [
  GMAIL_READ_SCOPE,
  GMAIL_SEND_SCOPE,
  ...LOGIN_GOOGLE_OAUTH_SCOPES,
];

export const ENRICH_OAUTH_SCOPES: string[] = [
  GMAIL_READ_SCOPE,
  GMAIL_SEND_SCOPE,
  ...LOGIN_GOOGLE_OAUTH_SCOPES,
];

export enum GoogleCallbackLinks {
  connectCallback = "/api/connectGoogleCallback",
  linkCallback = "/api/linkGoogleCallback",
}

export const ALLOWED_EMAILS = [
  "dev@supercharge.finance",
  "ben@joincape.ai",
  "ben@supercharge.finance",
  "jim@supercharge.finance",
  "kai@joincape.ai",
  "daryl@joincape.ai",
  "li.noelle@gmail.com",
  "chuachdaryl@gmail.com",
  "vishnu.sundaresan@gmail.com",
  "andallomargen@gmail.com",
  "encarnacionmargie32@gmail.com",
  "jack@joincape.ai",
  "meetings@joincape.ai",
  "mitchell@joincape.ai",
  "ops@joincape.ai",
  "drafters@joincape.ai",
  "kenneth.valencia445@gmail.com",
  "johnangeloong09@gmail.com",
  "trixbasco6@gmail.com",
  "luke.pothen@gmail.com",
  "nnatesanderss@gmail.com",
  "wierzbickicaitlyn@gmail.com",
  "fayth4snyder7@gmail.com",
  "joyann060306@gmail.com",
  "valentinevernis@gmail.com",
  "hyun@joincape.ai",
];
